import { Pipe, PipeTransform, Injectable, inject } from '@angular/core';
import moment from 'moment';
import Session from '../utils/session.service';
import Config from '../utils/config.service';

@Pipe({ name: 'lastMessageTime', standalone: true })
@Injectable({providedIn: 'root'})
export class LastMessageTimePipe implements PipeTransform {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	
	transform(time) {
		var user: any = this.session.getSession().user;
		var language: any = (user.deviceLanguage || this.config.getSettings().DEFAULT_LANG).slice(0, 2);
		var momentTime: any = moment(time);
		return momentTime.locale(language).calendar(null, {
			sameDay: 'HH:mm',
			lastDay: 'ddd HH:mm',
			lastWeek: 'ddd HH:mm',
			sameElse: 'D MMM HH:mm'
		});
	}
	
}